export const buildUrl = (...routes: string[]) => routes.join("/");
